// extracted by mini-css-extract-plugin
module.exports = {"list":"CreateBaseStorageMoveModal_list__d8ONY"};